module.exports = __webpack_public_path__ + "img/mimosa.add0fdbc.jpg";